import { render, staticRenderFns } from "./CustomSelectBox.vue?vue&type=template&id=065e233f&"
import script from "./CustomSelectBox.vue?vue&type=script&lang=js&"
export * from "./CustomSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports